import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { JWTToken } from 'src/app/contracts/jst-token';
import { User } from 'src/app/entity/user';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  backendUrlBase = environment.backendUrl + 'api/user';
  jwtHelper = new JwtHelperService();
  redirectUrl = '';
  private readonly authenticated = new BehaviorSubject<boolean>(
    !this.jwtHelper.isTokenExpired(this.getToken())
  );

  constructor(private httpClient: HttpClient, private router: Router) { }

  login(user: User): Observable<JWTToken> {
    const requestUrl = this.backendUrlBase + '/login';

    return this.httpClient.post<JWTToken>(requestUrl, user).pipe(
      tap(() => {
        this.authenticated.next(true);
      })
    );
  }

  logout(): void {
    this.authenticated.next(false);
    this.router.navigate(['/login']);
  }

  getHttpAuthorizationHeader(): any {
    const token = this.getToken();

    return {
      Authorization: 'Bearer ' + token,
    };
  }

  getToken(): string {
    return localStorage.getItem('token');
  }

  get isAuthenticated() {
    return this.authenticated.asObservable();
  }

  isAdmin(): boolean {
    const token = this.getToken();

    if (token) {
      const decodedToken = this.jwtHelper.decodeToken(token);
      if (decodedToken) {
        return decodedToken.role === 'Admin';
      }
    }
    return false;
  }

  getUserId(): string {
    const token = this.getToken();

    const userId = this.jwtHelper.decodeToken(token).nameid;

    return userId;
  }
}
